module.exports = __webpack_public_path__ + "static/media/manager.7baa9a16.svg";